'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _components = {
	_$Number: {
		displayName: 'Number'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Number = (function (_Component) {
	_inherits(Number, _Component);

	function Number() {
		_classCallCheck(this, _Number);

		_Component.apply(this, arguments);
	}

	Number.prototype.getValue = function getValue() {
		var value = _reactDom2['default'].findDOMNode(this).value;
		if (value.length == 0) {
			return;
		}
		return value.replace(',', '.');
	};

	Number.prototype.handleChange = function handleChange(e) {
		if (this.props.onChange) {
			this.props.onChange(this.getValue());
		}
	};

	Number.prototype.handleBlur = function handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.getValue());
		}
	};

	Number.prototype.render = function render() {
		var _this = this;

		var value = typeof this.props.value != 'undefined' && this.props.value != null ? this.props.value.toString() : '';
		value = value.replace('.', ',');
		return _react2['default'].createElement('input', _extends({ type: 'text',
			ref: 'input'
		}, this.props, {
			value: value,
			onChange: function (e) {
				return _this.handleChange(e);
			},
			onBlur: function (e) {
				return _this.handleBlur(e);
			}
		}));
	};

	_createClass(Number, null, [{
		key: 'rules',
		value: {
			numericality: {
				message: 'Hodnota musí být číslo!'
			}
		},
		enumerable: true
	}]);

	var _Number = Number;
	Number = _wrapComponent('_$Number')(Number) || Number;
	return Number;
})(_Component2['default']);

exports['default'] = Number;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/NumberBase.js
 ** module id = 1037
 ** module chunks = 1
 **/